import AddElementLayout from "../layouts/AddElementLayout";
import * as Yup from 'yup';
import TextInput from "../inputs/TextInput";
import { Button, Col, Row } from "antd";
import { openNotification } from "../../helpers/alerts";
import { postData, updateData, getData } from "../../helpers/api";
import SelectInput from "../inputs/SelectInput";
import { useEffect, useState } from "react";

const AddSheetMapping = (props) => {
    const {
        handleAfterAddingSheetMapping,
        initialValue,
        isModalOpen,
        handleCancel
    } = props;

    const [products, setProducts] = useState([]);

    // Fetch products data
    useEffect(() => {
        getProducts();
    }, []);

    const getProducts = async () => {
        try {
            const res = await getData("/products");
            setProducts(res.data.map((product) => ({ value: product.id, label: product.name })));
        } catch (error) {
            console.log(error);
        }
    };

    const saveSheetMapping = async (values, submitProps) => {
        try {
            // Transform column mapping values to numbers and ensure product is the ID
            const transformedValues = {
                sheetName: values.sheetName,
                product: parseInt(values.product) || values.product, // Ensure it's the product ID
                columnMapping: {
                    name: parseInt(values.nameColumn) || 0,
                    phone: parseInt(values.phoneColumn) || 0,
                    address: parseInt(values.addressColumn) || 0,
                    price: parseInt(values.priceColumn) || 0,
                    orderDate: parseInt(values.orderDateColumn) || 0,
                    unit: parseInt(values.unitColumn) || 0,
                    sheetId: parseInt(values.sheetId) || 0,
                }
            };

            if (values.id) {
                await updateData(`/sheet-mapping/${values.id}`, transformedValues);
                openNotification(`Le mapping de feuille a été mis à jour avec succès`, 'success');
            } else {
                await postData("/sheet-mapping", transformedValues);
                openNotification(`Le mapping de feuille a été ajouté avec succès`, 'success');
            }
            submitProps.resetForm();
            handleAfterAddingSheetMapping();
        } catch (error) {
            if (error.response?.status === 409) {
                openNotification(`Le mapping de feuille existe déjà`, 'error');
                return;
            }
            if (error.response?.status === 404) {
                openNotification(`Produit non trouvé`, 'error');
                return;
            }
            console.error('Error saving sheet mapping:', error);
            openNotification(`Erreurs côté serveur`, 'error');
        }
    };

    // Prepare initial form values with existing data for edit mode
    const formInitialValues = {
        ...initialValue,
        product: initialValue.product?.id || null,
        nameColumn: initialValue.columnMapping?.name || '',
        phoneColumn: initialValue.columnMapping?.phone || '',
        addressColumn: initialValue.columnMapping?.address || '',
        priceColumn: initialValue.columnMapping?.price || '',
        orderDateColumn: initialValue.columnMapping?.orderDate || '',
        unitColumn: initialValue.columnMapping?.unit || '',
        sheetId: initialValue.columnMapping?.sheetId || '',
    };

    return (
        <AddElementLayout
            title={initialValue.id ? "Mettre à jour le mapping de feuille" : "Ajouter un mapping de feuille"}
            isModalOpen={isModalOpen}
            handleCancel={handleCancel}
            initialValue={formInitialValues}
            validationSchema={Yup.object({
                sheetName: Yup.string().required('Le nom de la feuille est requis'),
                product: Yup.number().required('Le produit est requis'),
                nameColumn: Yup.number().required('La colonne nom est requise'),
                phoneColumn: Yup.number().required('La colonne téléphone est requise'),
                addressColumn: Yup.number().required('La colonne adresse est requise'),
                priceColumn: Yup.number().required('La colonne prix est requise'),
                orderDateColumn: Yup.number().required('La colonne date de commande est requise'),
                unitColumn: Yup.number().required('La colonne unité est requise'),
                sheetId: Yup.number().required('La colonne ID est requise'),
            })}
            handleSubmitForm={(values, submitProps) => {
                saveSheetMapping(values, submitProps);
            }}
        >
            <Row gutter={[16, 16]}>
                <Col xl={12} md={12} sm={24} xs={24}>
                    <TextInput
                        name="sheetName"
                        placeholder="Nom de la feuille"
                        size="large"
                    />
                </Col>
                <Col xl={12} md={12} sm={24} xs={24}>
                    <SelectInput
                        name="product"
                        size="large"
                        placeholder="Produit"
                        options={products}
                    />
                </Col>
                <Col xl={12} md={12} sm={24} xs={24}>
                    <TextInput
                        name="nameColumn"
                        placeholder="Index colonne nom"
                        size="large"
                        type="number"
                    />
                </Col>
                <Col xl={12} md={12} sm={24} xs={24}>
                    <TextInput
                        name="phoneColumn"
                        placeholder="Index colonne téléphone"
                        size="large"
                        type="number"
                    />
                </Col>
                <Col xl={12} md={12} sm={24} xs={24}>
                    <TextInput
                        name="addressColumn"
                        placeholder="Index colonne adresse"
                        size="large"
                        type="number"
                    />
                </Col>
                <Col xl={12} md={12} sm={24} xs={24}>
                    <TextInput
                        name="priceColumn"
                        placeholder="Index colonne prix"
                        size="large"
                        type="number"
                    />
                </Col>
                <Col xl={12} md={12} sm={24} xs={24}>
                    <TextInput
                        name="orderDateColumn"
                        placeholder="Index colonne date de commande"
                        size="large"
                        type="number"
                    />
                </Col>
                <Col xl={12} md={12} sm={24} xs={24}>
                    <TextInput
                        name="unitColumn"
                        placeholder="Index colonne unité"
                        size="large"
                        type="number"
                    />
                </Col>

                <Col xl={12} md={12} sm={24} xs={24}>
                    <TextInput
                        name="sheetId"
                        size="large"
                        placeholder="Index colonne ID"
                    />
                </Col>
                <Col xl={12} md={12} sm={24} xs={24}>
                    <Button
                        size='large'
                        type="primary"
                        htmlType="submit"
                        style={{ width: "100%" }}
                    >
                        {initialValue.id ? "Mettre à jour" : "Ajouter"}
                    </Button>
                </Col>
            </Row>
        </AddElementLayout>
    );
}

export default AddSheetMapping;
